import React from 'react'
import {Button} from '@/products/flexible-web-toolkit/components/button/button'
import {EllipseButton} from '@/products/flexible-web-toolkit/components/button/ellipse-button'
import {ButtonIcons} from '@/components/button-icons/button-icon'

interface Cta {
	url: string
	isExternal?: boolean
	text: string
}

interface OfficeDetailsProps {
	className?: string
	title?: string
	description?: string
	markerDescription?: string
	primaryContactNumber?: string
	secondaryContactNumber?: string
	emailAddress?: string
	ctaTitle?: string
	primaryCta?: Cta | null
	secondaryCta?: Cta | null
}

export const OfficeDetails: React.FC<OfficeDetailsProps> = ({
	className = '',
	title = '',
	description = '',
	markerDescription = '',
	primaryContactNumber = '',
	secondaryContactNumber = '',
	emailAddress = '',
	ctaTitle = '',
	primaryCta = null,
	secondaryCta = null,
}) => {
	return (
		<div className={`relative z-10 mx-auto bg-gray-100 p-4 ${className}`}>
			<h2 className="mb-4">{title}</h2>
			{markerDescription !== '<p><br></p>' ? (
				<div
					className="mb-4"
					dangerouslySetInnerHTML={{__html: markerDescription}}
				/>
			) : (
				<p className="mb-4">{description}</p>
			)}
			{primaryContactNumber ? (
				<a
					className="group mb-4 flex items-center font-semibold hover:underline focus:underline"
					href={`tel:${primaryContactNumber}`}
				>
					<EllipseButton
						as="span"
						className="mr-4 group-hover:bg-secondary"
						icon={ButtonIcons.Contact}
						iconSize="h-8 w-8"
					/>
					<span data-clarity-mask="true">{primaryContactNumber}</span>
				</a>
			) : null}
			{secondaryContactNumber ? (
				<a
					className="group mb-4 flex items-center font-semibold hover:underline focus:underline"
					href={`tel:${secondaryContactNumber}`}
				>
					<EllipseButton
						as="span"
						className="mr-4 group-hover:bg-secondary"
						icon={ButtonIcons.Contact}
						iconSize="h-8 w-8"
					/>
					<span data-clarity-mask="true">
						{secondaryContactNumber}
					</span>
				</a>
			) : null}
			{emailAddress ? (
				<a
					className="group mb-4 flex items-center font-semibold hover:underline focus:underline"
					href={`mailto:${emailAddress}`}
				>
					<EllipseButton
						as="span"
						className="mr-4 w-12 flex-none group-hover:bg-secondary"
						icon={ButtonIcons.EmailInverted}
						iconSize="h-8 w-8"
					/>
					<span
						className="flex-initial"
						data-clarity-mask="true"
						style={{overflowWrap: 'break-word'}}
					>
						{emailAddress}
					</span>
				</a>
			) : null}
			{ctaTitle ? <h3 className="mb-4">{ctaTitle}</h3> : null}
			{primaryCta ? (
				<Button
					href={primaryCta.url}
					{...(primaryCta.isExternal
						? {target: '_blank', icon: ButtonIcons.External}
						: {})}
					className="mb-4 w-full"
				>
					{primaryCta.text}
				</Button>
			) : null}
			{secondaryCta ? (
				<Button
					href={secondaryCta.url}
					variant="secondary"
					{...(secondaryCta.isExternal
						? {target: '_blank', icon: ButtonIcons.External}
						: {})}
					className="mb-4 w-full"
				>
					{secondaryCta.text}
				</Button>
			) : null}
		</div>
	)
}
